<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <QAutoComplete v-model="statusfilter" :label="'Status'" :list="eventTypeList" :textkey="'Name'"
              :valuekey="'Name'" multiple clearable externaledit class="ma-3">
            </QAutoComplete>
            <!--
            <QDateTimeField v-model="start" :label="'after'"></QDateTimeField>
            <QDateTimeField v-model="end" :label="'before'"></QDateTimeField>
             -->
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getMailLogListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="100" :pk="pk">

          <template v-slot:list-item="{ item }">
            <v-row no-gutters class="px-3 py-2">
              <v-col cols="0" class="pr-3">
                <v-row no-gutters>
                  <v-col cols="auto" class="pr-3">
                    <v-chip small :dark="eventTypeColor(item.Status) != ''" :color="eventTypeColor(item.Status)">
                      {{ item.Status }}
                    </v-chip>
                  </v-col>
                  <v-col cols="0">
                    {{ item.TimeStamp }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  TO {{ item.Recievers }} Cc {{ item.CCs }}
                </v-row>
              </v-col>
              <v-col cols="8">
                <v-card v-html="item.Status == 'Failed' ? item.Text : item.Body" flat color="transparent"
                  :class="item.open ? '' : 'compressedText'" @click="toggleCollapse(item)">
                </v-card>
              </v-col>
            </v-row>
          </template>
        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import Vue from "vue";

export default {
  name: "AdminFailureCodes",
  props: {},
  components: {
    FilterPane,
    ListPane,
    Layout,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "MLL-",
      eventTypeList: [
        { Id: 1, Name: "Success", Color: "quaternary" },
        { Id: 2, Name: "Failed", Color: "error" },
      ],
    };
  },

  mounted() { },

  methods: {
    eventTypeColor(type) {
      var color = "";
      var eventTypeMap = {
        'Success': 'quaternary',
        'Failed': 'error',
      };
      if (type in eventTypeMap) {
        color = eventTypeMap[type];
      }
      return color;
    },

    toggleCollapse(item) { Vue.set(item, "open", !item.open); }
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          TypeList: this.typefilter,
        };
        return filters;
      }
      else {
        return null;
      }
    },

    statusfilter: {
      get() { return this.getQueryParam("filter-status", []); },
      set(update) { this.setQueryParam("filter-status", update); },
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
.compressedText {
  overflow-wrap: break-word;
  line-clamp: 3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>